import "./lib/install-fetch-base";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { BrandProvider } from "@/lib/brand-context";
import { GlobalProvider } from "@/context/GlobalContext";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrandProvider>
      <GlobalProvider>
        <RouterProvider router={router} />
      </GlobalProvider>
    </BrandProvider>
  </React.StrictMode>,
);
